import { CONSTANTS } from '../constants/index'

import auth from '../authentication'
import { getUrlParams } from '../util'

function addSignupModal(config) {
  let signupModal = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_SIGNUP)

  if (signupModal.length === 0) {
    signupModal = document.createElement(CONSTANTS.COMPONENTS.MODAL_SIGNUP)
    signupModal.config = config

    signupModal.show = false
    signupModal.addEventListener('close', () => { signupModal.show = false })
    signupModal.addEventListener('signUpSuccess', () => { signupModal.show = false })
    signupModal.addEventListener('showLogin', () => { showLoginModal() })

    document.body.appendChild(signupModal)
  }
}

function addLoginSignupModal(config) {
  let signupModal = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN_SIGNUP)

  if (signupModal.length === 0) {
    signupModal = document.createElement(CONSTANTS.COMPONENTS.MODAL_LOGIN_SIGNUP)
    signupModal.config = config

    signupModal.show = false
    signupModal.addEventListener('close', () => { signupModal.show = false })
    signupModal.addEventListener('signUpSuccess', () => { signupModal.show = false })
    signupModal.addEventListener('showLogin', () => { showLoginModal() })

    document.body.appendChild(signupModal)
  }
}

function addLoginModal() {
  let loginModal = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN)

  if (loginModal.length === 0) {
    loginModal = document.createElement(CONSTANTS.COMPONENTS.MODAL_LOGIN)
    loginModal.addEventListener('close', () => { loginModal.show = false })
    loginModal.addEventListener('showSignup', () => { showSignupModal() })
    loginModal.addEventListener('loginSuccess', () => { auth.onLogin() })
    loginModal.addEventListener('showForgetPassword', () => { showForgetPaswordModal() })

    const params = getUrlParams('show-login')
    loginModal.show = params['show-login']

    document.body.appendChild(loginModal)
  }
}

function addForgotPasswordModal() {
  let forgotPasswordModal = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_FORGOT_PASSWORD)

  if (forgotPasswordModal.length === 0) {
    forgotPasswordModal = document.createElement('ae-forgot-password-modal')
    forgotPasswordModal.show = false
    forgotPasswordModal.addEventListener('close', () => { forgotPasswordModal.show = false })
    forgotPasswordModal.addEventListener('showSignup', () => { showSignupModal() })
    forgotPasswordModal.addEventListener('showLogin', () => { showLoginModal() })

    document.body.appendChild(forgotPasswordModal)
  }
}

function addCheckoutModal(options) {

  const {
    packagesPageUrl,
    enablePostPurchaseBtn,
    postPurchaseBtnLabel,
    postPurchaseBtnLink,
    showProductCategoryInCheckout,
    continueBuyInCart
  } = options;

  let checkoutModal = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_CHECKOUT)

  if (checkoutModal.length === 0) {
    checkoutModal = document.createElement(CONSTANTS.COMPONENTS.MODAL_CHECKOUT)
    checkoutModal.addEventListener('close', () => { 
      checkoutModal.open = false 
    })
    checkoutModal.addEventListener('continueBuying', () => {
      checkoutModal.open = false
      if(continueBuyInCart && continueBuyInCart !== window.location.pathname){
        window.location.href = continueBuyInCart
      }else{
        if (packagesPageUrl && packagesPageUrl !== window.location.pathname) {
          window.location.href = packagesPageUrl
        }
      }
    })
    checkoutModal.addEventListener('toLogin', () => {
      checkoutModal.open = false
      showLoginModal()
    })

    const params = getUrlParams('show-checkout')

    let interval = setInterval(()=>{
      if(document.querySelector('ae-checkout-modal')){
        setTimeout(()=>{
          checkoutModal.open = params['show-checkout'] || false
        },100)
        clearInterval(interval)
      }
    },200)

    if (enablePostPurchaseBtn && postPurchaseBtnLabel) {
      checkoutModal.postPurchaseBtnLabel = postPurchaseBtnLabel;
    }

    checkoutModal.addEventListener('postPurchase', () => {
      checkoutModal.open = false

      if (postPurchaseBtnLink && postPurchaseBtnLink !== window.location.pathname) {
        window.location.href = postPurchaseBtnLink
      }
    })

    checkoutModal.showProductCategory = showProductCategoryInCheckout

    document.body.appendChild(checkoutModal)
  }
}

function showSignupModal(event) {
  if (event) {
    event.preventDefault()
  }

  const signupHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_SIGNUP)
  const modalSignupCollection = [...signupHtmlCollection]
  modalSignupCollection.forEach(signupModal => { signupModal.show = true })

  const loginHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN)
  const modalLoginCollection = [...loginHtmlCollection]
  modalLoginCollection.forEach(loginModal => { loginModal.show = false })
}

function showLoginSignupModal(event) {
  if (event) {
    event.preventDefault()
  }

  const signupHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN_SIGNUP)
  const modalSignupCollection = [...signupHtmlCollection]
  modalSignupCollection.forEach(signupModal => { signupModal.show = true })

  // const loginHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN_SIGNUP)
  // const modalLoginCollection = [...loginHtmlCollection]
  // modalLoginCollection.forEach(loginModal => { loginModal.show = false })
}

function showLoginModal(event, { disableSSORedirect } = { disableSSORedirect: false }) {
  if (event) {
    event.preventDefault()
  }

  if (!disableSSORedirect) {
    const isLogged = window.AngularEcommerce.web.stores.getters['auth/isLogged']

    if (!isLogged && window.AngularEcommerce.web.config.useSSO) {
      const client = new window.AngularEcommerce.web.util.createCrossDomainCookieClient();
      client.get();
      return;
    }
  }

  const loginHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN)
  const modalLoginCollection = [...loginHtmlCollection]
  modalLoginCollection.forEach(loginModal => { loginModal.show = true })

  const signupHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_SIGNUP)
  const modalSignupCollection = [...signupHtmlCollection]
  modalSignupCollection.forEach(signupModal => { signupModal.show = false })
}

function showForgetPaswordModal(event) {
  if (event) {
    event.preventDefault()
  }

  const loginHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_LOGIN)
  const modalLoginCollection = [...loginHtmlCollection]
  modalLoginCollection.forEach(loginModal => { loginModal.show = false })

  const forgotPasswordHtmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_FORGOT_PASSWORD)
  const modalForgotPasswordCollection = [...forgotPasswordHtmlCollection]
  modalForgotPasswordCollection.forEach(forgotPasswordModal => { forgotPasswordModal.show = true })
}

function showCheckoutModal(event) {
  if (event) {
    event.preventDefault()
  }
  const htmlCollection = document.getElementsByTagName(CONSTANTS.COMPONENTS.MODAL_CHECKOUT)
  const modalCollection = [...htmlCollection]
  modalCollection.forEach(modal => { 
    modal.open = true;
  })
  
}

export default {
  showSignupModal,

  showLoginModal,

  showForgetPaswordModal,

  showCheckoutModal,

  showLoginSignupModal,

  addModalComponents({ signupModal, checkout, loginSignupModal }) {
    addSignupModal(signupModal)
    addLoginSignupModal(loginSignupModal)
    addLoginModal()
    addForgotPasswordModal()
    addCheckoutModal(checkout)
  }
}
